import {isFeatureEnabled} from '@github-ui/feature-flags'
import {Spinner} from '@primer/react'
import {clsx} from 'clsx'
import {createContext, use} from 'react'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './TimelineDivider.module.css'

/** Set to false to hide the vertical line between rows. The spacing stays. */
export const TimelineConnectorContext = createContext(true)

type TimelineDividerProps = {
  isLoading?: boolean
  isHovered?: boolean
  id?: string
  showLine?: boolean
}

export const TimelineDivider = ({isLoading, isHovered, id, showLine = true}: TimelineDividerProps) => {
  const showConnector = use(TimelineConnectorContext)

  return (
    <div
      data-testid={id ? TEST_IDS.timelineDivider(id) : undefined}
      className={clsx(
        styles.Box,
        isFeatureEnabled('issue_inline_avatars') && styles.Box_inlineAvatars,
        isLoading && styles.loading,
      )}
    >
      {isLoading ? (
        <Spinner size={'small'} />
      ) : (
        <>
          {showConnector && showLine && (
            <div data-testid={TEST_IDS.timelineDividerConnector} className={styles.Box_1} />
          )}
          <div className={clsx(styles.Box_2, isHovered && styles.hovered)} />
        </>
      )}
    </div>
  )
}
